import tooltip from 'bootstrap/js/dist/tooltip'

const emTooltip = {
  mounted(el, binding) {
    let tooltipRef = null
    el.addEventListener('mouseenter', () => {
      tooltipRef = new tooltip(el, {
        title: binding.value,
        placement: 'top',
        fallbackPlacements: []
      })
      tooltipRef.show()
    })
    el.addEventListener('mouseleave', () => {
      tooltipRef?.dispose()
    })
  }
}

export default emTooltip
